/* Independent navigation survives unrelated enhancement errors. */
(() => {
  document.addEventListener('click', event => {
    const sheet=document.getElementById('HzSheet');
    if(sheet?.open && event.target.closest('[data-hz-close]'))sheet.close();
  });
  document.addEventListener('click', event => {
    const trigger=event.target.closest('.header__icon--menu');
    const sheet=document.getElementById('HzSheet');
    const template=document.getElementById('HzCategories');
    if(!trigger || !sheet?.showModal || !template) return;
    event.preventDefault();event.stopImmediatePropagation();
    document.querySelector('cart-drawer.active')?.close();
    const native=trigger.closest('header-drawer');
    if(native?.querySelector('details[open]')) native.closeMenuDrawer(new Event('click'),trigger);
    document.getElementById('HzSheetTitle').textContent='House of Zainab';
    document.getElementById('HzSheetBody').replaceChildren(template.content.cloneNode(true));
    sheet.classList.add('hz-menu-drawer');trigger.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('hz-lock');
    if(!sheet.open)sheet.showModal();sheet.querySelector('[data-hz-close]').focus();
    sheet.addEventListener('close',()=>{document.documentElement.classList.remove('hz-lock');trigger.setAttribute('aria-expanded','false');if(trigger.isConnected)trigger.focus();},{once:true});
  },true);
})();
